import { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { StatisticsContent } from '@starjack/entities/statistics';
import { StatisticsDynamicPricingContent } from '@starjack/entities/statistics';
import { Environment } from '@starjack/entities/environment';
import { useGetB2BUsersQuery } from '@starjack/entities/b2b';
import { useTranslation } from 'react-i18next';

export type DashboardContentProps = {
    environments: Environment[];
};

export const DashboardContent = ({ environments }: DashboardContentProps) => {
    const [value, setValue] = useState('1');
    const { t } = useTranslation();
    const { data: b2bUsersData } = useGetB2BUsersQuery();
    const b2bUsers = (b2bUsersData?.b2bUsers ?? []).map((u) => ({
        id: u.id,
        name: u.name,
    }));

    const handleChange = (_event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <TabContext value={value}>
            <TabList
                variant='scrollable'
                allowScrollButtonsMobile
                slotProps={{
                    scrollButtons: {
                        sx: {
                            '&.Mui-disabled': {
                                width: 0,
                                minWidth: 0,
                                padding: 0,
                                overflow: 'hidden',
                            },
                        },
                    },
                }}
                sx={{
                    mb: { xs: 2, md: 4 },
                    borderBottom: 1,
                    borderColor: 'divider',
                    px: 0,
                    '& .MuiTabs-flexContainer': { gap: 1 },
                }}
                onChange={handleChange}
            >
                <Tab label={t('generalSalesStatistics')} value='1' />
                <Tab label={t('salesStatisticsByOffer')} value='2' />
            </TabList>

            <TabPanel value='1' sx={{ pt: 2, px: 0 }}>
                <StatisticsContent
                    environment={environments}
                    b2bUsers={b2bUsers}
                />
            </TabPanel>

            <TabPanel value='2' sx={{ pt: 2, px: 0 }}>
                <StatisticsDynamicPricingContent
                    environments={environments}
                    b2bUsers={b2bUsers}
                />
            </TabPanel>
        </TabContext>
    );
};
